<template>
  <div class="search-lib-page full-parent" :class="isClient ? '' : 'search-brower'">

    <div class="scroll-content">
      <!-- 输入搜索区域 -->
      <search-input @fresh-search="freshSearch" ref="SearchInput" />

      <!-- 排序方式 -->
      <other-filter :count="count" @search="handleCurrentChange({ page: 1 })" ref="OtherFilter" />
      
      <!-- 产品列表 -->
      <div v-loading="loading" style="padding: 4px 16px 0 16px;">

        <div class="prod-list-area">
          <div class="prod-list-content">

            <ad-advert :comp="comp" v-for="comp in adverts" :key="comp.AdvID"></ad-advert>

            <comp-card :data="item" :cardType="2" v-for="(item, index) of dataSource" :key="index"></comp-card>

            <div class="list-card-empty comp" v-for="item of 20" :key="`key_${item}`"></div>
          </div>
        </div>
        <!-- <el-empty description="搜索不到呀~" v-else></el-empty> -->
      </div>
    </div>
    <div class="list-pagination">
      <md-page :page="page" :total="count" :pageSize="pageSize" @pagecallback="handleCurrentChange"></md-page>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapMutations } from 'vuex';
import {AdvertsType, AdvertsService, CheckLibs} from '@digital-supply-chain/module'

import SearchInput from "../components/search-input.vue";
import CompCard from "@/components/comp-card.vue";
import { UtilService } from "@/libs";
import { TodaySearchService } from "@/service";

import OtherFilter from "./components/other-filter.vue";
import AdAdvert from "./components/ad-advert.vue";

export default {
  components: {
    SearchInput,
    CompCard,
    OtherFilter,
    AdAdvert
  },
  data() {
    return {
      page: 1,
      pageSize: 50,
      count: 0,
      dataSource: [], // 产品列表

      loading: false,

      adverts: [],
      isClient: CheckLibs.isClient(),
    };
  },
  computed: {
    ...mapGetters({
      historys:'search/historys',
    }),
  },
  methods: {
    ...mapMutations({
      setSearchHistory: 'search/setSearchHistory'
    }),

    getParams() {
      let keyword = this.$refs.SearchInput.keyword || this.$route.params.keyword; // 避免用户将搜索框删除后进行操作
      let { sort, showAdv } = this.$refs.OtherFilter;
      let data = {
        keyword, // 关键词
        page: this.page, // 页码
        pageSize: this.pageSize, // 页数
        cId: '', // cId
        sort,
        highlight: true,
        showAdv,
      };
      return data;
    },

    // 获取产品列表
    async compGetSlist(page = 1) {
      this.loading = true;
      if (page === 1) {
        this.page = 1;
      } else {
        this.dataSource = [];
      }
      this.equalityData = [];
      let data = this.getParams();
      data.keyword && (this.setSearchHistory(data.keyword));
      const res = await TodaySearchService.searchCompany(
        data.keyword,
        data.sort,
        data.page,
        data.pageSize
      );
      if (res.code === 0) {
        this.dataSource = res.data.list.map(item => {
          let newItem = {};
          Object.keys(item).forEach(v => {
            newItem[v.slice(0, 1).toUpperCase() + v.slice(1)] = item[v];
          })
          newItem.CompName = UtilService.getHighLightHtml(data.keyword, newItem.CompName);
          return newItem;
        });
        this.count = res.data.count || 0;
      }
      this.loading = false;
    },

    // 重置地址，以实现关键词的变更，其他筛选项的状态重置
    freshSearch(keyword) {
      this.$router.replace(`/search/lib/${keyword}`);
    },
    pageStart(keyword) {
      this.$refs.SearchInput.keyword = keyword; // 修改搜索输入框中的文字
      this.compGetSlist();
      this.$refs.SearchInput.getSearchKeyword(); // 获取关联词
    },
    // 分页搜素
    handleCurrentChange(_page) {
      this.page = _page.page;
      this.compGetSlist(_page.page);

      this._getAdvert();
    },

    // 广告部分
    async _getAdvert() {
      let data = this.getParams();
      if (!data.showAdv) {
        this.adverts = [];
        return false;
      }
      const res = await AdvertsService.queryAdverts({
        type: AdvertsType.SearchComp,
        limit: this._getRowCount(),
        random: true,
        match: true,
        keyword: data.keyword
      });
      if (res) {
        this.adverts = res;
      }
    },
    /**一行显示的数量 */
    _getRowCount() {
      const viewWidth = document.querySelector('.prod-list-content').clientWidth;
      const listWidth = document.querySelector('.list-card-empty').clientWidth;
      return parseInt(viewWidth / listWidth, 10);
    },

  },
  mounted() {
    let { keyword } = this.$route.params;
    document.title = `企业：${keyword}`;
    this.pageStart(keyword);

    this._getAdvert();
  },
};
</script>
<style lang="less" scope>
.search-lib-page {
  display: flex;
  flex-direction: column;
  position: relative;
  width: 100%;
  padding: 16px 0;
  overflow-x: hidden;
  &.search-brower{
    padding-top: 52px;
  }
  p {
    margin: 0;
  }
}

.equality-list-content{
  display: flex;
  flex-wrap: wrap;
  height: 241px;
  margin-bottom: 10px;
}

.search-filter{
  margin-top: 16px;
}

.scroll-content {
  flex: 1;
}

.prod-list-area {
  width: 100%;
}

.prod-list-content{
  display: flex;
  flex-wrap: wrap;
}
.prod-list-block {
  min-width: 150px;
  max-width: 180px;
  margin: 0 5px 10px 5px;
  flex: 1;
  border: 1px solid #d6d6d6;
  position: relative;
  &>.list-card{
    margin: 0;
    position: initial;
    height: 100%;
    border: 0 none;
  }
}

.list-pagination {
  position: sticky;
  left: 0;
  bottom: 0;
}

.badge-m{
  position: absolute;
  top: 0px;
  right: 0px;
  font-size: 12px;
  color: #ffffff;
  width: 32px;
  height: 16px;
  text-align: center;
  background: rgba(51, 51, 51, 0.6);
  line-height: 15px;
}
</style>